import crypto from "crypto";

// API呼び出す時、こちらのKEYを使う
/**  ローカル実行時
 手動で`.env.local`に
 VUE_APP_ENCRYPTION_KEY={{key}}
 を追加してください
*/
const encryptionKey = process.env.VUE_APP_ENCRYPTION_KEY;

/**
開発時、暗号化(複合化)確認方法
//vueファイルにimport
import { encryptAES256CBC } from "@/utils/Encrypt.js";
...
//コンソールとして出力する
key省略するとVUE_APP_ENCRYPTION_KEYを使用
iv省略すると16桁ランダムascii文字列を使用
const encrypted = encryptAES256CBC("Hello, World.",{{key}},{{iv}});
console.log("encrypted:", encrypted);
 
 */
/**
 * AES256-CBC暗号化メソッド
 * @param {string} plaintext - 暗号化する平文
 * @param {string} key - 暗号化キー（32文字）
 * @param {string} iv - 初期化ベクトル（16文字）
 * @returns {string} Base64エンコードされた暗号化結果（IV + 暗号化データ）
 */
function encryptAES256CBC(
  plaintext,
  key = encryptionKey,
  iv = generateRandomIV()
) {
  if (key.length !== 32) {
    throw new Error("Key must be exactly 32 characters long");
  }
  if (iv.length !== 16) {
    throw new Error("IV must be exactly 16 characters long");
  }

  const cipher = crypto.createCipheriv("aes-256-cbc", key, iv);
  let encrypted = cipher.update(plaintext, "utf8", "base64");
  encrypted += cipher.final("base64");

  // IVと暗号化データを結合してBase64エンコード
  const ivBuffer = Buffer.from(iv, "ascii");
  const encryptedBuffer = Buffer.from(encrypted, "base64");
  const combined = Buffer.concat([ivBuffer, encryptedBuffer]);

  return combined.toString("base64");
}

/**
 * AES256-CBC復号化メソッド
 * @param {string} encryptedData - Base64エンコードされた暗号化データ
 * @param {string} key - 復号化キー（32文字）
 * @returns {string} 復号化された平文
 */
function decryptAES256CBC(encryptedData, key = encryptionKey) {
  if (key.length !== 32) {
    throw new Error("Key must be exactly 32 characters long");
  }

  // Base64デコードしてIVと暗号化データを分離
  const combined = Buffer.from(encryptedData, "base64");
  const iv = combined.subarray(0, 16).toString("ascii");
  const encrypted = combined.subarray(16).toString("base64");

  const decipher = crypto.createDecipheriv("aes-256-cbc", key, iv);
  let decrypted = decipher.update(encrypted, "base64", "utf8");
  decrypted += decipher.final("utf8");

  return decrypted;
}

/**
 * ランダムな16文字のASCII文字列（IV用）を生成
 * @returns {string} 16文字のランダムASCII文字列
 */
function generateRandomIV() {
  // ASCII印刷可能文字範囲 (32-126) から特殊文字を除外した安全な文字セット
  const asciiChars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()-_=+[]{}|;:,.<>?";
  let iv = "";

  for (let i = 0; i < 16; i++) {
    const randomIndex = Math.floor(Math.random() * asciiChars.length);
    iv += asciiChars[randomIndex];
  }

  return iv;
}

export { encryptionKey, encryptAES256CBC, decryptAES256CBC, generateRandomIV };
